/**
 * 전체 페이지 로딩 상태 표시 스피너.
 * 데이터 페칭 중 isLoading === true 일 때 페이지 컨텐츠 대신 렌더링한다.
 */
export default function LoadingSpinner() {
  return (
    <div className="flex flex-col justify-center items-center h-64">
      <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      <p className="text-gray-600 mt-4">로딩 중...</p>
    </div>
  );
}
